import { makeAutoObservable } from 'mobx';
import { ActingRole } from '../types';
import apiConfig from '../api/routes';
import i18next from 'i18next';
import { notification, NotificationType } from '@iba-team/portal-react-components/dist';

class ActingPerson {
  constructor() {
    makeAutoObservable(this);
  }
  actingRoles: ActingRole[] = [];
  getEmployeeList = async (roleId: number, query: string) => {
    return await apiConfig.actingPerson.getEmployeeList(roleId, query);
  };

  getActingRoles = async () => {
    this.actingRoles = await apiConfig.actingPerson.getActingRoles();
  };

  updateRoles = (resRole: ActingRole) => {
    this.actingRoles = this.actingRoles.map(i => {
      if (i.roleId === resRole.roleId) {
        return resRole;
      }
      return i;
    });
  };
  addActing = async (role: ActingRole) => {
    const res = await apiConfig.actingPerson.addActing(role);
    this.updateRoles(res);
    notification.open({
      type: NotificationType.SUCCESS,
      title: i18next.t('success'),
      description: i18next.t('acting_roles.alert.add.success')
    });
    return res;
  };

  updateActing = async (role: ActingRole) => {
    const res = await apiConfig.actingPerson.updateActing(role);
    this.updateRoles(res);
    notification.open({
      type: NotificationType.SUCCESS,
      title: i18next.t('success'),
      description: i18next.t('acting_roles.alert.update.success')
    });
    return res;
  };

  deleteActing = async (id: number) => {
    const res = await apiConfig.actingPerson.deleteActing(id);
    this.updateRoles(res);
    notification.open({
      type: NotificationType.SUCCESS,
      title: i18next.t('success'),
      description: i18next.t('acting_roles.alert.delete.success')
    });
    return res;
  };
}

export const Acting = new ActingPerson();
